/* What a name may look like, checked before the request.

   These three numbers are the server's — `users/use_cases.py` holds the same ones, and
   `UsernameChangeSerializer` enforces them whatever this file says. They are duplicated here for
   one reason: a player typing a name should be told it is too short while they are typing it,
   not after a round trip that refuses them. The server stays the rule; this is the courtesy.

   Returns an i18n key and its values, or null when there is nothing to say — the same shape the
   editor needs to render a line under the field. */

export const USERNAME_MIN_LENGTH = 3
export const USERNAME_MAX_LENGTH = 20
export const USERNAME_CHARACTERS = /^[A-Za-z0-9_.-]+$/

export const usernameProblem = (name) => {
  const trimmed = (name ?? "").trim()

  if (trimmed.length < USERNAME_MIN_LENGTH) {
    return { key: "settings.usernameTooShort", values: { count: USERNAME_MIN_LENGTH } }
  }
  if (trimmed.length > USERNAME_MAX_LENGTH) {
    return { key: "settings.usernameTooLong", values: { count: USERNAME_MAX_LENGTH } }
  }
  if (!USERNAME_CHARACTERS.test(trimmed)) {
    return { key: "settings.usernameCharacters", values: {} }
  }
  return null
}

export default usernameProblem
